import React, { useEffect, useState } from 'react';

export const EntraConfigChecker = () => {
    const [configStatus, setConfigStatus] = useState(null);

    useEffect(() => {
        const checkConfig = () => {
            const clientId = process.env.REACT_APP_ENTRA_CLIENT_ID;
            const authority = process.env.REACT_APP_ENTRA_AUTHORITY;
            const redirectUri = process.env.REACT_APP_ENTRA_REDIRECT_URI;

            const issues = [];

            if (!clientId || clientId === 'your-client-id') {
                issues.push('REACT_APP_ENTRA_CLIENT_ID is not set or is default value');
            }

            if (!authority || authority.includes('your-tenant-id')) {
                issues.push('REACT_APP_ENTRA_AUTHORITY is not set or contains placeholder');
            }

            if (!redirectUri) {
                issues.push('REACT_APP_ENTRA_REDIRECT_URI is not set');
            }

            if (issues.length > 0) {
                setConfigStatus({
                    valid: false,
                    issues,
                    message: 'MSAL configuration incomplete. Check environment variables.'
                });
            } else {
                setConfigStatus({
                    valid: true,
                    message: 'MSAL configuration looks good.'
                });
            }
        };

        checkConfig();
    }, []);

    // Only show in development
    if (process.env.NODE_ENV === 'production') {
        return null;
    }

    if (!configStatus) {
        return null;
    }

    return (
        <div style={{
            position: 'fixed',
            bottom: '10px',
            right: '10px',
            padding: '10px',
            backgroundColor: configStatus.valid ? '#e8f5e9' : '#ffebee',
            color: configStatus.valid ? '#2e7d32' : '#c62828',
            borderRadius: '4px',
            border: `1px solid ${configStatus.valid ? '#4caf50' : '#ef5350'}`,
            fontSize: '12px',
            maxWidth: '300px',
            zIndex: 9999,
        }}>
            <div><strong>MSAL Config:</strong> {configStatus.message}</div>
            {!configStatus.valid && (
                <ul style={{ margin: '5px 0 0 0', paddingLeft: '15px' }}>
                    {configStatus.issues.map((issue, index) => (
                        <li key={index}>{issue}</li>
                    ))}
                </ul>
            )}
        </div>
    );
};
